import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';

function CarouselComp({ images }) {
    return (
        <Carousel style={{ height: 'auto', maxHeight: '480px', borderRadius: 14, width: '100%', objectFit: 'cover', overflow: 'hidden' }}>
            {images.map((image, index) => (
                <Carousel.Item key={index}>
                    <img
                        style={{ height: '100%', width: '100%', objectFit: 'cover' }}
                        src={image}
                    />
                </Carousel.Item>
            ))}
        </Carousel>
    );
}

export default CarouselComp;